import { Controller } from "@hotwired/stimulus";
import { put } from '@rails/request.js'

export default class extends Controller {
  static targets = ["menu"]
  static values = {
    updateUrl: String,
  }

  abortController = undefined

  resetOrStartAbortController(){
    if(this.abortController){
      delete this.abortController;
    }

    this.abortController = new AbortController();
  }

  toggleMenu() {
    if (this.menuTarget.classList.contains('hidden')){
      this.resetOrStartAbortController()

      document.addEventListener(
        'click',
        (e) => {
          if (!this.element.contains(e.target)){
            this.toggleMenu();
          }
        },
        {
          signal: this.abortController.signal,
        },
      );
      this.menuTarget.classList.replace('hidden', 'visible');
    } else {
      this.abortController.abort('Clicked Outside');
      this.menuTarget.classList.replace('visible', 'hidden');
    }
  }

  async selectStatus(e){
    const { target: { dataset: { statusId } } } = e

    if (this.updateUrlValue){
      await put(this.updateUrlValue, {
        contentType: 'application/json',
        body: JSON.stringify({
          status_id: statusId === 'unassigned' ? null : statusId,
        }),
        responseKind: 'turbo-stream',
      })
    }
  }
}